// Тосты приложения (ux.md, «Нет связи»): без связи тосты об успехе не показываются. Связь
// тосты читают в момент показа — у клиента API (последний запрос): операция, чей ответ вернул
// связь («Повторить» после обрыва), показывает свой тост об успехе сразу, не дожидаясь
// перерисовки с новым состоянием связи.
import { ToastProvider } from '@kp/ui';
import type { ReactNode } from 'react';
import { isOnline } from '../api/client.ts';

const offline = () => !isOnline();

export function AppToasts({ children }: { children: ReactNode }) {
  return <ToastProvider offline={offline}>{children}</ToastProvider>;
}
